export class RoleDto {
  keyId: string = '';
  id: string = '';
  appId: string = '';
  code: string = '';
  name: string = '';
  level: number = 99;
}